import { deferScript } from '@confluence/dom-helpers';
import { fg } from '@confluence/feature-gating';

import { ResourceRecorder } from './ResourceRecorder';

export class SuperbatchResourceRecorder extends ResourceRecorder {
	private includeSuperBatch: boolean;
	private includeConnect: boolean;
	private connectResource: string;
	private isJS: boolean;

	constructor(isJS: boolean) {
		super();
		this.includeConnect = false;
		this.connectResource = '';
		this.isJS = isJS;
		this.includeSuperBatch = false;
	}

	reset() {
		super.reset();
		this.includeSuperBatch = false;
		this.includeConnect = false;
		this.connectResource = '';
	}

	includeSuperBatchResources() {
		this.includeSuperBatch = true;
	}

	includeConnectWebResources() {
		// Connect web resources always need superbatch, so we need to include both if we're including connect
		this.includeSuperBatchResources();
		this.includeConnect = true;
	}

	get() {
		if (!this.includeSuperBatch) return '';
		if (!this.isJS) return this.resource;

		return this.includeConnect &&
			(fg('content_early_connect_iframe_initialization') ||
				fg('content_early_connect_iframe_initialization_part_2'))
			? this.resource
			: deferScript(this.resource);
	}

	addConnectResource(connectResource: string) {
		if (this.connectResource) {
			this.connectResource += '\n';
		}
		this.connectResource += connectResource;
	}

	getConnect() {
		// connect always need superbatch.
		// When confluence_always_preload_superbatch is enabled, we preload superbatch and not adding it to this recorder
		return (!!this.get() || fg('confluence_always_preload_superbatch')) &&
			this.includeConnect &&
			(fg('content_early_connect_iframe_initialization') ||
				fg('content_early_connect_iframe_initialization_part_2'))
			? this.connectResource
			: '';
	}
}
